export default {
  updatePartnerActivity(state, data) {
    for (var i = 0; i < data.length; i++) {
      data[i]['value'] = false;
    }
    state.partnerActivity = data;
  },

  updatePartner(state, data) {
    state.partner = data;
  },

  updatePartnerActivityValue(state, value) {
    state.partnerActivity[value.index].value = value.val;
  }
}
